module.exports = __webpack_public_path__ + "media/images/features/4/album/main-3-270205052b2b216ea21b923f4708e76d.jpg";